 // ----------------------
// 新增文字渐显动画逻辑
// ----------------------
document.addEventListener('DOMContentLoaded', () => {
  const animatedElements = document.querySelectorAll('.common-transform-show-p50');
  
  // 检查元素是否在视口中（放宽条件：元素只要和视口有交集就触发）
  function isInViewport(element) {
    const rect = element.getBoundingClientRect();
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    // 只要元素的顶部 < 视口高度，且底部 > 0，就认为在视口中（覆盖底部元素）
    return rect.top < viewportHeight && rect.bottom > 0; 
  }
  
  // 为在视口中的元素添加active类
  function handleScroll() {
    animatedElements.forEach(element => {
      if (isInViewport(element) && !element.classList.contains('active')) {
        setTimeout(() => {
          element.classList.add('active');
        }, 100); // 添加小延迟使动画更自然
      }
    });
  }
  
  // 初始检查
  handleScroll();
  
  // 滚动时检查
  window.addEventListener('scroll', handleScroll);
});